export const ERROR_RECORD_NOT_FOUND = 1001;
export const ERROR_ACCOUNT_NOT_EXIST = 2000;
export const ERROR_EMAIL_EXPIRED = 5007;
export const TEMP_REPORT_EXPIRED = 32000;

export default {};
